import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'react-loader-spinner';
import * as MDICONS from '@material-ui/icons';
import { openCompanyUpdateModal } from '../../../store/actions/companyActions';
import ReactModal from 'react-modal';
import logo from '../../../assets/logo/roundedLogo.png'
import styled from "styled-components";
import EditCompanyForm from '../../company/dashboardComponent/settings/EditCompanyForm'
import CompanyProfile from '../../company/CompanyProfile';
import MinimalCompanyProfile from '../../company/MinimalCompanyProfile';
import CompanyNotificationDrawer from '../../notifications/CompanyNotificationDrawer';
import CompanyVisibileModal from '../../company/dashboardComponent/settings/companyVisibileModal';

const CompanyEditButton = styled.div`

    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.backgroundColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

class DashboardCompany extends Component {

    constructor(props) {
        super()

        this.state = {
            showEditFormModal: false,
            showVisibileModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.props.openCompanyUpdateModal();
        this.setState({ showEditFormModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showEditFormModal: false });
    }

    /// README: MODAL CONTROLLING
    handleOpenCompanyVisibilityModal = () => {

        this.setState({ showVisibileModal: true, });
    }

    handleCloseCompanyVisibilityModal = () => {
        this.setState({ showVisibileModal: false });
    }


    render() {
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }

        /// README: CHECK IF COMPANY DATA AND COMPANY BRIEFINGS DATA IS NOT UNDEFINED
        if (this.props.companyData && this.props.companyBriefingsData) {
            const { companyData, themeColors, modalStyles, company, dashboardSidebarSize, userData, alu } = this.props;
            const { isCompanyUpdated } = company;
            const { companyName, email, profilePic, phone, address, accessMap, coid } = companyData;
            const { uid, employeeid } = userData;
            const { companyDashboardOnlyAccess } = alu;
            var ueid = uid + employeeid;
            var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
            const { visibility, creatorUid } = companyData;
            const visibilityCheck = visibility ? 'Make company invisible' : 'Make company visibile';

            return (
                <div className="container-fluid">
                    <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>

                        {/* EDIT MODAL */}
                        <ReactModal
                            style={modalStyles}
                            isOpen={this.state.showEditFormModal && !isCompanyUpdated === true}
                            onRequestClose={() => { this.handleCloseModal() }}
                            contentLabel="Add new tag"
                            ariaHideApp={false}
                        >
                            <button className="close" onClick={() => { this.handleCloseModal() }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <EditCompanyForm />
                        </ReactModal>
                        {/*COMPANY VISIBILITY MODAL*/}
                        <ReactModal
                            style={modalStyles}
                            isOpen={this.state.showVisibileModal}
                            onRequestClose={() => { this.handleCloseCompanyVisibilityModal() }}
                            contentLabel="visiblilty"
                            ariaHideApp={false}
                        >
                            <button className="close" onClick={() => { this.handleCloseCompanyVisibilityModal() }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <CompanyVisibileModal />
                        </ReactModal>

                        {/* HEADER */}
                        <h5 className="card-header" >
                            <div className="d-flex justify-content-between">
                                {/* NAME, EMAIL AND DP */}
                                <div className="d-flex flex-row">
                                    <div className="align-self-center">
                                        <img src={(profilePic ?? "") === "" ? `https://avatars.dicebear.com/api/identicon/${coid}.svg?backgroundColor=%23ffffff` : profilePic} alt="company" className="avatar-square" style={{ width: "90px", height: "90px" }} />
                                    </div>
                                    <div className="align-self-center ml-4">
                                        <div className="d-flex flex-column">
                                            <div className="align-self-center"><h4><b>{companyName}</b></h4></div>
                                            <div className="align-self-center"><p style={{ fontSize: "17px" }}>{email}</p></div>
                                        </div>
                                    </div>
                                </div>

                                {/* COMPANY EDITING BUTTON */}
                                {
                                    companyDashboardOnlyAccess[accessLevel] ?
                                        <div className="d-flex flex-row">
                                            <div className="align-self-center"><CompanyNotificationDrawer /></div>
                                            &nbsp; &nbsp;
                                            <div className="align-self-center">
                                                <div className="d-flex flex-column">

                                                    {creatorUid === uid ?
                                                        <div className="align-self-center">
                                                            <CompanyEditButton themeColors={themeColors}>
                                                                <div className="btn-group">

                                                                    <button type="button" className="btn btn-default btn-sm " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                        <MDICONS.Settings />
                                                                    </button>
                                                                    <div className="dropdown-menu p-4">
                                                                        <p className="dropdown-item" style={{ fontSize: '14px', fontWeight: 'bold', color: 'black', cursor: 'pointer', backgroundColor: 'white' }} onClick={this.handleOpenModal}>Edit company</p>

                                                                        <div className="dropdown-divider"></div>
                                                                        <p className="dropdown-item" style={{ fontSize: '14px', fontWeight: 'bold', color: 'black', cursor: 'pointer', backgroundColor: 'white' }} onClick={this.handleOpenCompanyVisibilityModal}>{visibilityCheck}</p>
                                                                    </div>
                                                                </div>
                                                            </CompanyEditButton>

                                                        </div>
                                                        :
                                                        <div className="align-self-center">
                                                            <CompanyEditButton themeColors={themeColors}>
                                                                <button className="btn btn-default btn-sm" style={{ borderRadius: '10px' }} onClick={this.handleOpenModal}>
                                                                    <MDICONS.Edit /> {" "} Edit company
                                                                </button>
                                                            </CompanyEditButton>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        : <React.Fragment />}
                            </div>
                        </h5>

                        {(companyDashboardOnlyAccess[accessLevel]) ? <CompanyProfile /> : <MinimalCompanyProfile />}
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className="container-fluid">
                    <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '150px' }}>
                        <div className="card p-3 pt-5">
                            <Loader
                                type="TailSpin"
                                color={this.props.themeColors.themeColor}
                                height={50}
                                width={50}
                            />
                            <br></br>
                            <p style={textStyle}>Loading your company...</p>
                            <br></br>
                        </div>
                    </div>
                </div>
            )
        }
    }

}

const mapStateToProps = (state) => {
    return {

        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        modalStyles: state.appControl.modalStyles,
        company: state.company,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
        alu: state.alu,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openCompanyUpdateModal: () => dispatch(openCompanyUpdateModal()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(DashboardCompany);
